export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/78489dd5fe22b2b724f99f5861a7cee7.svg";